import Dashboard from "layouts/Dashboard/Dashboard";
import ForgotPassword from "views/ForgotPassword/ForgotPassword";
import ResetPassword from "views/ResetPassword/ResetPassword";
import ForceChangePassword from "views/ForceChangePassword/ForceChangePassword";
// import Login from 'views/Login/Login';

import CognitoLogin from 'views/Login/Cognito/CognitoLogin';
import LoginCallback from 'views/Login/Cognito/LoginCallback';
import LogoutCallback from 'views/Login/Cognito/LogoutCallback';
import Login from "views/Login/Login";

// please make sure to keep all public (non-protected) routes above the protected routes

// TODO: make two nested objects for indexRoutes namely protectedRoutes and publicRoutes
// and render the publicRoutes first in index.js to ensure right order
var indexRoutes = [
  { path: "/login", name: "Login", component: Login },
  { path: "/forgot-password", name: "ForgotPassword", component: ForgotPassword },
  { path: "/reset-password", name: "ResetPassword", component: ResetPassword },
  { path: "/force-change-password", name: "ForceChangePassword", component: ForceChangePassword },
  {
    path: "/login/cognito", name: "Cognito Login", component: CognitoLogin
  },
  {
    path: "/login/oauth2/code/cognito", name: "Login Callback", component: LoginCallback
  },
  {
    path: "/logout", name: "Logout Callback", component: LogoutCallback
  },
  { path: "/*", name: "Home", component: Dashboard, isProtected: true },
];

export default indexRoutes;
